/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
	openTopic,
	closeTopic,
	resetTopic,
	destroyTopic,

	pushMessage,
	pushMessages,
	updateMessage,
	deleteMessage,

	clearAll,

	// unique message type functionality
	removeAllInitializingMonitorMessages,
} = createActions(
	{
		OPEN_TOPIC: ({ topic }) => ({ topic }),
		CLOSE_TOPIC: ({ topic }) => ({ topic }),
		RESET_TOPIC: ({ topic }) => ({ topic }),
		DESTROY_TOPIC: ({ topic }) => ({ topic }),

		PUSH_MESSAGE: ({ topic, message }) => ({ topic, message }),
		PUSH_MESSAGES: ({ topic, messages }) => ({ topic, messages }),
		UPDATE_MESSAGE: ({ topic, message }) => ({ topic, message }),
		DELETE_MESSAGE: ({ topic, message }) => ({ topic, message }),

		CLEAR_ALL: () => ({}),

		// unique message type functionality
		REMOVE_ALL_INITIALIZING_MONITOR_MESSAGES: ({ topic }) => ({ topic }),
	},
	{ prefix: ROOT_SLICE }
);

export { 
	openTopic,
	closeTopic,
	resetTopic,
	destroyTopic,

	pushMessage,
	pushMessages,
	updateMessage,
	deleteMessage,

	clearAll,

	// unique message type functionality
	removeAllInitializingMonitorMessages,
 };
